window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
import observeAndExecute from './utils/observe-and-execute';
const fCarousels = require('./components/carousels');
const fInfoPopup = require('./components/info-popup')
const fRegisterPopup = require('./components/register-popup')
import vueComponents from "./components/vue-components";
const fVideoPopup = require('./components/video-popup');


const fSelect = require('./components/select');

observeAndExecute("[data-lazy-src]", {
    callback: el => el.setAttribute("src", el.dataset.lazySrc),
})

document.addEventListener("DOMContentLoaded", function() {

    fRegisterPopup()
    fSelect.init();
    fVideoPopup();
    vueComponents([
        { name: "map-section", file: () => import('./vue/map-section.vue')},
    ]);
    fInfoPopup();
    observeAndExecute(".swiper", {
        callback: () => fCarousels.init(),
        disconnect: true,
    })
    
});
document.addEventListener( 'wpcf7mailsent', function( event ) {
    document.querySelectorAll("form.wpcf7-form > :not(.wpcf7-response-output)").forEach(el => {
        el.style.display = 'none';
    });
}, false );

AOS.init({
    // Global settings:
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
});


